export const CLONE_META_DATA_SUCCESS = 'CLONE_META_DATA_SUCCESS';
export const CLONE_META_DATA_FAILURE = 'CLONE_META_DATA_FAILURE';

export const CLONE_COUNT_META_DATA_SUCCESS = 'CLONE_COUNT_META_DATA_SUCCESS';
export const CLONE_COUNT_META_DATA_FAILURE = 'CLONE_COUNT_META_DATA_FAILURE';
